module.exports = __webpack_public_path__ + "img/top-image.3146889c.svg";